export const axiosTimeout = 360000;
